import { render, staticRenderFns } from "./SACTableFooter.vue?vue&type=template&id=eb2e6ffe"
import script from "./SACTableFooter.vue?vue&type=script&lang=js"
export * from "./SACTableFooter.vue?vue&type=script&lang=js"
import style0 from "./SACTableFooter.vue?vue&type=style&index=0&id=eb2e6ffe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports